import queryString from 'query-string';

const useQuery = () => queryString.parse(window.location.search);

export default useQuery;
